import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';
import SubSidebar from './sidebar';
import { InvalidAccess } from '../../../utils/sessionDataHandle';
import { useAppContext } from '../../../context/AppContext';

import AnalyticsConnectors from './Connectors';
import AnalyticsIntegrations from './Integrations';
import AddIntegrations from './AddIntegrations';

function DataSource() {

    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const styles = getStyles(theme);
    const { selectedWorkspace, selectedProject } = useAppContext();
    const [selectedMenuItem, setSelectedMenuItem] = useState(0);

    useEffect(() => {
        if (!selectedWorkspace || !selectedProject) {
            InvalidAccess(navigate);
            return
        }
        const selected_engine_name = selectedProject?.payload?.configuration?.engine_name
        if (location.pathname === '/sources') {
            if (selected_engine_name === "analytics_tool") {
                navigate('/sources/analytics-tool/connectors');
            }
        }
    }, [location.pathname, navigate]);

    const handleMenuChange = (engine, path) => {
        if (engine && path) {
            navigate(`/sources/${engine?.toLowerCase()?.replace(/_/g, '-')}/${path?.toLowerCase()?.replace(/_/g, '-')}`);
        }
    };

    return (
        <Box sx={styles.mainContainer}>
            <Box sx={styles.sidebar}>
                <SubSidebar
                    handleMenuChange={handleMenuChange}
                    setSelectedMenuItem={setSelectedMenuItem}
                    selectedMenuItem={selectedMenuItem}
                />
            </Box>
            <main style={styles.componentContainer}>
                <Box sx={styles.cardContainer}>
                    <Routes>
                        <Route path="analytics-tool/connectors" element={<AnalyticsConnectors setSelectedMenuItem={setSelectedMenuItem} />} />
                        <Route path="analytics-tool/integrations" element={<AnalyticsIntegrations />} />
                        <Route path="analytics-tool/integrations/*" element={<AddIntegrations setSelectedMenuItem={setSelectedMenuItem} />} />
                    </Routes>
                </Box>
            </main>
        </Box>
    )
}

export default DataSource;